import { storage } from '@uhg-abyss/web/tools/storage';
import { createHashHistory } from 'history';
import { configureStore } from '@sde/widgets-core/src/redux/store';
import { getDefaultMiddleware } from '@sde/widgets-core/src/redux/middleware/getDefaultMiddleware';
import { createRouterMiddleware } from '@sde/widgets-core/src/redux/router/middleware';
import { routerReducer } from '@sde/widgets-core/src/redux/router/reducer';
import { configureAppStore } from '@src/state/store';

const routerHistory = typeof window !== 'undefined' ? createHashHistory() : {};
const routerMiddleware = createRouterMiddleware(routerHistory);

const routerStore = configureStore({
  reducer: routerReducer(routerHistory),
  middleware: [...getDefaultMiddleware(), routerMiddleware],
});

const store = configureAppStore();

if (typeof window !== 'undefined') {
  storage.window.set('sde-redux-store', store);
  storage.window.set('sde-router-store', routerStore);
}

export { store, routerStore };
